class CommonContants {
  static NUXEO_DATE_FORMAT = "MMMM DD, YYYY";

  static FILTER_FIRST_PAGE = 0;
  static FILTER_MIN_PAGE_SIZE = 1;
  static FILTER_MAX_PAGE_SIZE = 100;
  static FILTER_DEFAULT_PAGE_SIZE = 30;

  static FILE_VIEWS_THUMBNAIL = 0;
  static FILE_VIEWS_THUMBNAIL_TEXT = "Thumbnail";
  static FILE_VIEWS_SMALL = 1;
  static FILE_VIEWS_SMALL_TEXT = "Small";
  static FILE_VIEWS_MEDIUM = 2;
  static FILE_VIEWS_MEDIUM_TEXT = "Medium";
  static FILE_VIEWS_LARGE = 3;
  static FILE_VIEWS_LARGE_TEXT = "Full HD";
  static FILE_VIEWS_ORIGINAL = 4;
  static FILE_VIEWS_ORIGINAL_TEXT = "Original";

  static ARCHIVE_ASSETS_FILE_TYPE = "FileArchive";
  static ACTIVE_ASSETS_FILE_TYPE = "liveFile";
  static MIXED_ASSETS_FILE_TYPE = "MixedFile";

  static FILE_VIEWS = [
    {
      value: CommonContants.FILE_VIEWS_THUMBNAIL,
      text: CommonContants.FILE_VIEWS_THUMBNAIL_TEXT,
    },
    {
      value: CommonContants.FILE_VIEWS_SMALL,
      text: CommonContants.FILE_VIEWS_SMALL_TEXT,
    },
    {
      value: CommonContants.FILE_VIEWS_MEDIUM,
      text: CommonContants.FILE_VIEWS_MEDIUM_TEXT,
    },
    {
      value: CommonContants.FILE_VIEWS_LARGE,
      text: CommonContants.FILE_VIEWS_LARGE_TEXT,
    },
    {
      value: CommonContants.FILE_VIEWS_ORIGINAL,
      text: CommonContants.FILE_VIEWS_ORIGINAL_TEXT,
    },
  ];

  static ARCHIVE_PROPERTIES_TO_SHOW = {
    "archive_file:archiveApplication.id": "Source Application",
    "archive_file:archiveClassification.id": "File Type",
    "archive_file:archiveSubmission.title": "Archive Submission Title",
    "archive_file:archiveVersionCategory": "File Version Type",
    "archive_file:archiveSubmissionId": "Submission ID",
    "archive_file:archiveSubmissionStage": "Submission Stage",
    "archive_file:archiveSubmissionDate": "Submission Date",
    "archive_submission:lineOfBusiness": "Line of Business",
    "archive_submission:workfrontProjectJobId": "Workfront Project Job ID",
    "archive_submission:contract": "Contract",
    "archive_submission:productCategoryId": "Product Category ID",
    "archive_submission:productCategoryName": "Product Category Name",
    "archive_submission:productDetailName": "Product Detail Name",
    "archive_submission:productTypeId": "Product Type ID",
    "archive_submission:productTypeName": "Product Type Name",
    "archive_submission:productDetailId": "Product Detail ID",
    "archive_submission:workfrontProjectId": "Workfront Project ID",
    "archive_submission:licenseeRefNo": "Licensee Ref #",
    "archive_submission:licenseePhone": "Licensee Phone",
    "archive_submission:licenseeFax": "Licensee Fax",
    "archive_submission:licenseeEmail": "Licensee E-Mail",
    "archive_submission:property": "Property",
    "archive_submission:propertyName": "Property Name",
    "archive_submission:territory": "Territory",
    "archive_submission:contractStatus": "Contract Status",
    "archive_submission:artProgram": "Art Program",
    "archive_submission:aeName": "AE Name",
    "archive_submission:baRep": "BA Rep",
    "archive_submission:pd": "PD",
    "dc:description": "Description",
    "dc:title": "Asset Title",
    "archive_submission:product.prd_sku": "Archive SKU",
    "archive_submission:coordinator": "Coordinator",
    "archive_submission:jobStatus": "Job Status",
    "archive_submission:licensee": "Licensee",
    "archive_submission:licenseeContactName": "Licensee Contact Name",
    "archive_submission:licenseeName": "Licensee Name",
    "archive_submission:retailer": "Retailer",
    "archive_submission:lmsiOffice": "LMSI Office",
    "archive_submission:jobStage": "Job Stage",
    "archive_submission:jobCategory": "Job Category",
    "archive_submission:jobStartDate": "Job Start Date",
    "archive_submission:character": "Character",
    "archive_submission:jobStageCategory": "Job Stage Category",
    "archive_submission:jobLastStatusDate": "Job Last Status Date",
  };

  static ACTIVE_PROPERTIES_TO_SHOW = {
    "live_file:sourceApplication": "Source Application",
    "live_file:liveClassification": "File Type",
    "live_file:workfrontProjectJobId": "Workfront Project Job ID",
    "live_file:liveSku": "STAR LABS SKU",
    "live_file:liveSubmissionTitle": "STAR LABS Submission Title",
    "submission:productTypeName": "Product Type Name",
    "submission:targetGroup": "Target Group",
    "submission:jobTypeStage": "Job Type Stage",
    "submission:inMarketSeason": "In Market Season",
    "submission:propertyName": "Property Name",
    "submission:workfrontLicenseeGroupId": "Workfront Licensee Group Id",
    "submission:standardLegalNotice": "Standard Legal Notice",
    "submission:productCategoryName": "Product Category Name",
    "submission:internalRefId": "Internal Ref Id",
    "submission:contract": "Contract",
    "submission:parForm": "Par Form",
    "submission:productDetailName": "Product Detail Name",
    "submission:licenseeName": "Licensee Name",
    "submission:workfrontLicenseeCompanyId": "Workfront Licensee Company Id",
    "submission:lineOfBusiness": "Line Of Business",
    "submission:officeIdKey": "Office Id Key",
    "submission:associatedJobs": "Associated Jobs",
    "submission:jobStage": "Job Stage",
    "submission:productCategoryId": "Product Category ID",
    "submission:productTypeId": "Product Type ID",
    "submission:productDetailId": "Product Detail ID",
    "submission:workfrontProjectId": "Workfront Project ID",
    "submission:licenseeRefNo": "Licensee Ref #",
    "submission:licenseeEmail": "Licensee E-Mail",
    "submission:property": "Property",
    "submission:territory": "Territory",
    "submission:artProgram": "Art Program",
    "submission:baRep": "BA Rep",
    "dc:description": "Description",
    "dc:title": "Asset Title",
    "submission:jobStatus": "Job Status",
    "submission:licensee": "Licensee",
    "submission:retailer": "Retailer",
    "submission:lmsiOffice": "LMSI Office",
    "submission:jobCategory": "Job Category",
    "submission:jobStartDate": "Job Start Date",
    "submission:character": "Character",
    "submission:jobStageCategory": "Job Stage Category",
    "submission:jobLastStatusDate": "Job Last Status Date",
    "submission:additionalLegalNotice": "Additional Legal Notice",
    "submission:officeId": "Office Id",
    "submission:tierOfDistribution": "Tier Of Distribution",
    "submission:consumerTarget": "Consumer Target",
    "submission:abbreviatedLegalNotice": "Abbreviated Legal Notice",
    "submission:notes": "Notes",
    "submission:licenseeContactName": "Licensee Contact Name",
    "submission:submitStatus": "Submit Status",
    "submission:coordinator": "Coordinator",
    "submission:territories": "Territories",
    "submission:inMarketDate": "In Market Date",
    "submission:workfrontProjectGuid": "Workfront Project Guid",
    "submission:workfrontLicenseeTeamId": "workfront Licensee Team Id",
    "submission:asset": "Asset",
  };

  static MIXED_PROPERTIES_TO_SHOW = {
    Application: "Source Application",
    liveSku: "STAR LABS SKU",
    liveSubmissionTitle: "STAR LABS Submission Title",
    source: "Archive Submission Title",
    "product.prd_sku": "Archive SKU",
    jobStatus: "Job Status",
    jobStage: "Job Stage",
    jobStartDate: "Job Start Date",
    character: "Character",
    jobStageCategory: "Job Stage Category",
    jobLastStatusDate: "Job Last Status Date",
    productTypeName: "Product Type Name",
    productCategoryName: "Product Category Name",
    productDetailName: "Product Detail Name",
    licenseeName: "Licensee Name",
    archiveSubmissionDate: "Submission Date",
    propertyName: "Property Name",
    description: "Description",
    retailer: "Retailer",
    lmsiOffice: "LMSI Office",
    territories: "Territories",
    archiveSubmissionId: "Submission ID",
    contract: "Contract",
    jobTypeStage: "Job Type Stage",
    territory: "Territory",
    artProgram: "Art Program",
    contractStatus: "Contract Status",
    inMarketDate: "In Market Date",
  };
}

export default CommonContants;
